import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { TarjetasService } from '../../service/tarjetas.service';
import { Router } from '@angular/router';
import { PerfilService } from 'src/app/service/perfil.service';
import { LoginService } from '../../service/login.service';
import { VerifiCard } from '../../VerifiCard';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as moment from 'moment'
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-tarjetas',
  templateUrl: './tarjetas.component.html'
})
export class TarjetasComponent implements OnInit {
  env = false
  new = false;
  nTarjeta: string;
  nomTarjeta: string;
  cardSelected: string
  cards: any;
  titulo_modal: string;
  valid = true
  carga = false
  dni: any
  sesion: any
  dataRes = {
    card: { numTarjeta: 0 }
  };
  nuevaSolicitud = false;
  response: any;
  result: any;
  cardCompro: any
  tituloSolicitud: string = '';
  //creditCardData
  cardNumber: any
  realNumerCard: any
  cardName: any
  cardDate: any;
  cardCuotas = '';
  cardCVV: any;
  cardMonto: any;
  fav = false
  mov: any;
  modalError: any = false;
  modalButton: boolean = false;

  tipoClasif: any;
  desclas: any;
  codSubClass: any;
  numTarjetExt: any;
  bloqueo = '-1';
  clasif: any;
  nombres: any;
  apePaterno: any;
  apeMaterno: any;
  apeCasada: any;
  email: any;
  tel: any;
  monto: any;
  desc: any;
  tipo: any
  sexo: any;
  totalCards: any
  soliciExito = false
  loading = false;
  cardDateReal: any
  errorMonto: any;
  errorMonto2: any;
  error: any;
  date: any;
  hora: any;
  FormatDate: any;
  pinTarjeta: any
  validate = new VerifiCard;


  respuesta: boolean;
  fechaAux = new Date()
  errorFVTC: boolean;
  msjFVTC: string;

  fechNaci: string;

  session: {
    idUsuario: any; ksi: string, dpi: number
  };
  quetzalFormat = {
    digitGroupSeparator: "",
    maximumValue: "999",
    minimumValue: "0",
    decimalPlaces: "0",
    decimalPlacesShownOnBlur: "2",
    modifyValueOnWheel: false,
    onInvalidPaste: "ignore"
  }
  tarjetasAbt: any;


  constructor(private router: Router, private tarjetas: TarjetasService, private perfil: PerfilService,
    private login: LoginService, public dialog: MatDialog) {
    this.tarjetas.selectedCard.subscribe(tarjetas => this.cardSelected = tarjetas);
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
    this.dni = this.session.dpi

  }

  ngOnInit() {
    this.cardMonto = ''
    this.cardCuotas = '';
    this.respuesta = false;
    this.nTarjeta = "";
    this.nomTarjeta = "";
  }
  formatDate() {
    this.cardDateReal = this.cardDate
    var test = this.cardDate.match(/.{1,2}/g)
    this.cardDate = '';
    this.cardDate = test[0];
    this.cardDate += '/';
    this.cardDate += test[1]
  }

  deformatDate() {
    this.cardDate = this.cardDate.split('/').join('')
  }

  loaderOff($event) {
    this.dataRes = $event
  }

  edit(nTarjeta: string, nomTarjeta: string, fav: string) {
    this.titulo_modal = "Editar medio de acceso"
    this.new = false
    this.nTarjeta = "";
    this.nomTarjeta = "";
    this.show(true);
    this.nTarjeta = nTarjeta;
    this.nomTarjeta = nomTarjeta;

    this.fav = fav === 'S'


  }
  newCard() {
    this.titulo_modal = "Afiliar medio de acceso"
    this.nTarjeta = "";
    this.nomTarjeta = "";
    this.carga = false;
    this.new = true
    this.show(true);
  }

  addNewCard() {
    this.modalButton = true;
    this.modalError = "";
    this.loading = true;


    this.tarjetas.validacionMA(this.nTarjeta).subscribe(

      res => {
        let response = JSON.parse(res)
        if (response.resultado == 0) {
          let json = {
            KSI: this.session.ksi,
            idUsuarioWeb: this.session.idUsuario,
            indFavorita: "N",
            numTarjeta: this.nTarjeta,
            etiqueta: this.nomTarjeta
          }
          let jsons = {
            KSI: this.session.ksi,
            idUsuarioWeb: this.session.idUsuario,
          }

          this.tarjetas.newCard(json).subscribe(res => {
            if (res.estado == 0) {
              this.respuesta = true;
              this.tarjetas.getCards(jsons).subscribe(res => {
                this.tarjetas.addCards(res.resumenCols)
                this.totalCards = this.totalCards + 1;
                this.loading = false;
                this.show(false)
              })
            } else if (res.estado == 500) {
              this.respuesta = false;
              this.loading = false;
              this.modalError = "Medio de acceso ya se encuentra afiliado al usuario"
            } else {
              this.respuesta = false;
              this.loading = false;
              this.modalError = res.msjError
            }
            this.modalButton = false;
          }, () => {
            this.modalButton = false;
            this.loading = false;
            this.modalError = "Error al afiliar medio de acceso. Inténtelo más tarde.";
          })
        } else {
          this.modalButton = false;
          this.loading = false;
          this.modalError = "Medio de acceso inválido"
        }

      });

  }

  confirmarDelete() {
    this.modalButton = true;
    this.modalError = "";
    this.openDialog();
  }

  delete() {
    this.loading = true;
    let json = {
      KSI: this.sesion.idSession,
      numTarjeta: this.nTarjeta,
      idUsuarioWeb: this.sesion.usuarioWeb,
      dni: this.dni.dni,
    }
    this.tarjetas.deleteCard(json).subscribe(res => {
      if (res.numError == 0) {
        this.respuesta = true;
        this.tarjetas.addCards(this.cards.cards.filter(card => card.numTarjeta != this.nTarjeta))   //se elimina tarjeta borrada
        this.totalCards = this.totalCards - 1;
        if (this.totalCards < 1) {
          this.router.navigate(['pocae/resumen/'])
        }
        this.loading = false;
        this.show(false)
      } else {
        this.respuesta = false;
        this.loading = false;
        this.modalError = res.msjError
      }
    }, () => {
      this.loading = false;
      this.modalError = "Error al desafiliar tarjeta. Inténtelo más tarde.";
    })
  }

  onlyNumber($event) {
    let key = $event.charCode;
    if (key <= 57 && key >= 48) {
      return true;
    } else {
      return false
    }
  }



  validaFechaTC() {
    this.errorFVTC = false;
    const x = moment()
    const aux = moment(this.cardDate, 'MMYY');
    const month = new Date().getMonth() + 1
    const year = new Date().getFullYear().toString().substring(2)

    if (this.cardDate.substr(0, 2) <= 12) {
      if (month + year == this.cardDate) this.errorFVTC = false;
      else {
        this.errorFVTC = moment(aux).isBefore(x)
        this.msjFVTC = "Fecha no puede ser menor a la actual."
      }
    }
    else {
      this.errorFVTC = true;
      this.msjFVTC = "No existe mes " + (this.cardDate.substr(0, 2)) + "."
    }
  }


  deFormat() {
    this.cardNumber = this.cardNumber.split(' ').join('');
  }

  tagCard() {
    this.modalButton = true;
    let json = {
      KSI: this.sesion.idSession,
      numTarjeta: this.nTarjeta,
      etiqueta: this.nomTarjeta,
      indFavorita: this.fav ? "S" : "N",
      idUsuarioWeb: this.sesion.usuarioWeb,
    }

    let jsons = {
      KSI: this.sesion.idSession,
      idUsuarioWeb: this.sesion.usuarioWeb
    }

    this.tarjetas.tagCard(json).subscribe(res => {
      this.response = res;
      if (this.response.numError != 0) {
        this.modalError = this.response.msjError
        if (this.response.numError == 2400) {
          this.login.addSession('', '', '', '', '');
        }
      } else {
        if (res.numError === 0) {
          this.tarjetas.getCards(jsons).subscribe(res => {
            this.tarjetas.addCards(res.resumen)
            this.show(false)
          })
        }
      }
    }, () => {
      this.loading = false;
      this.respuesta = false;
      this.modalButton = false;
      this.modalError = "Error al intentar editar tarjeta. Intente más tarde.";
    })
  }

  favCard(numTarjeta, fav) {
    this.fav = !fav
  }

  comprobante() {
    this.titulo_modal = "Comprobante de Compra"
    this.new = false;
    this.carga = false;
    this.result = true;
  }
  solicitud(response: boolean) {
    this.nuevaSolicitud = response
  }
  show(cerrar: boolean) {
    this.pinTarjeta = '';
    this.carga = false;
    this.result = false

    if (!cerrar) {
      this.modalError = "";
      this.cardMonto = ''
    }
    else {
      this.modalButton = false;
      this.error = false;
    }
    this.env = cerrar
    this.cardCVV = '';
    this.cardCuotas = '';
    this.cardNumber = '';
    this.cardDate = '';
    this.cardName = '';
    this.validaFechaTC();
    this.valid = true;
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogDesafiliacion, {
      data: {
        numeroTarjeta: this.nTarjeta
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.delete()
      }
      this.modalButton = false;
    });
  }
}

export interface DialogData {
  numeroTarjeta: number;
}

@Component({
  selector: 'dialog-desafiliacion',
  templateUrl: 'dialog-desafiliacion.html',
})
export class DialogDesafiliacion {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) { }
}